// @ts-nocheck
export interface WorkingHoursType {
  WorkingHoursID: number;
  CrmRelationID: number;
  DayOfWeek: string;
  StartOfWorkingDay: string;
  StartOfLunch?: string;
  EndOfLunch?: string;
  EndOfWorkingDay: string;
  IsActive: boolean;
}
export enum DayOfWeekEnum {
  Monday = 1,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
  Sunday,
}
